const DisplayOption = Object.freeze({
  TABLE: 'TABLE',
  COLUMN: 'COLUMN',
  BAR: 'BAR',
  PIE: 'PIE',
  AREA: 'AREA',
  HONEYCOM: 'HONEYCOM',
  BUBBLE: 'BUBBLE',
  WORDCLOUD: 'WORDCLOUD',
  AUTHOR: 'AUTHOR',
  GEO: 'GEO'
})
export default DisplayOption
export type DisplayOptionStrings = typeof DisplayOption[keyof typeof DisplayOption]
// RESERVE BELOW
